import React from 'react'
import styled from "styled-components";
import {UserDispatcherContext} from "@providers/user";
import ButtonBase from "../../atoms/button.base";
import {isEmpty} from "../../helpers/helpers";

function InvestmentBannerGridView({userModality, isBadeSaba = false, title = '', children, eventSection, eventView}) {
    const userDispatcherContext = React.useContext(UserDispatcherContext);

    const setInvestModalShow = () => {
        userDispatcherContext({
            type: 'MODALITY',
            payload: {
                type: userModality.type,
                city_id: userModality.city_id,
                city_name: userModality.city_name,
                show_invest: userModality.show_invest,
                show_invest_modal: true,
                isBadeSaba: isBadeSaba,
                event_section: eventSection,
                event_view: eventView,
                page: 'properties-list',
            },
        })
    };

    const defaultTitle = 'ملک موردنظرتون رو پیدا نکردین؟';

    return (
        <Container className="rounded-16 p-32 d-flex flex-column justify-content-center">
            <div className="investment-banner-content">
                <h3 className="h2 investment-banner-title">{!isEmpty(title) ? title : defaultTitle}</h3>
                <p className="">
                    {
                        !isEmpty(children) ?
                            children
                            :
                            <span>
                                کارشناسان 2نبش با همکاری شبکه‌ای از دفاتر املاک معتبر،  درخواست شما رو پیگیری می‌کنند.
                            </span>
                    }
                </p>

                <ButtonBase
                    onClick={setInvestModalShow}
                    color="primary"
                    size="sm"
                    className="mt-16">ثبت درخواست</ButtonBase>
            </div>
        </Container>
    )
}

export default React.memo(InvestmentBannerGridView);

// styles

const Container = styled.div`
    position: relative;
    background-image: url(/_img/investment/grid-banner.jpg);
    background-color: ${props => props.theme.gray100};
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 50%;
`;